import React from "react";
import { Card, CardContent, Typography, Box, Chip } from "@mui/material";

export default function ListItemCard(props) {
  const { title, subtitle, amount, status, rightMeta, statusColor = "default" } = props;

  return (
    <Card
      sx={{
        bgcolor: "transparent",
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        boxShadow: 0,
      }}
    >
      <CardContent>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1 }}>
          <Box>
            <Typography variant="subtitle1" fontWeight="bold">{title}</Typography>
            <Typography variant="body2" color="text.secondary">{subtitle}</Typography>
          </Box>
          <Box sx={{ textAlign: "right" }}>
            <Typography variant="h6" fontWeight="bold">{amount}</Typography>
            {rightMeta && (
              <Typography variant="caption" color="text.secondary">{rightMeta}</Typography>
            )}
          </Box>
        </Box>
        <Chip label={status} size="small" color={statusColor} />
      </CardContent>
    </Card>
  );
}
